import { exists } from '@/api'

export interface BatchReturnDbUpdateCondition {
  outputMode: string
}

export function BatchReturnDbUpdateConditionFromJSON(
  json: any
): BatchReturnDbUpdateCondition {
  const _json = JSON.parse(json)

  return {
    outputMode: exists(_json, 'output_mode') ? _json.output_mode : ''
  }
}
